import type { CuratedItem } from "~types/types";
import {
    type IntegrityStatus,
    checkItemArrayIntegrity,
} from "~utils/moduleIntegrity";

interface StoryListSimpleIntegrityProps {
    items?: CuratedItem[];
}

export default function integrityCheck({
    items = [],
}: StoryListSimpleIntegrityProps): IntegrityStatus {
    return checkItemArrayIntegrity(items, ["url", "headline"]);
}
